module.exports = __webpack_public_path__ + "img/img_safety_img1.5be0e4d2.png";